import React from 'react';
export function IdentificationSection() {
  const cards = [{
    icon: '😤',
    title: 'Querés ingresos, no sabés qué vender',
    desc: 'Buscás una idea rentable desde casa pero todo parece complicado, saturado o requiere demasiado capital.',
    highlight: false
  }, {
    icon: '😰',
    title: 'Cero experiencia en cocina',
    desc: 'Nunca hiciste una gelatina en tu vida y creés que esto es solo para personas con talento o años de práctica.',
    highlight: false
  }, {
    icon: '💸',
    title: 'YouTube te dejó más confundida',
    desc: 'Buscaste tutoriales gratis, intentaste seguirlos y terminaste desperdiciando ingredientes sin resultados.',
    highlight: false
  }, {
    icon: '📦',
    title: 'Ya intentaste vender y nadie compró',
    desc: 'Pusiste energía en un emprendimiento anterior y los resultados no llegaron porque faltaba el sistema correcto.',
    highlight: false
  }, {
    icon: '📱',
    title: 'No sabés cómo conseguir clientes',
    desc: 'Tenés ganas de emprender pero nadie te enseñó cómo atraer compradores, qué cobrar o cómo publicar para vender.',
    highlight: false
  }, {
    icon: '✅',
    title: 'Esto es exactamente para vos',
    desc: 'Gelatinas de Lujo te da el método completo: crear, fotografiar, publicar y vender. Todo en un solo lugar.',
    highlight: true
  }];
  return <section className="bg-bg2 py-16 px-5" data-id="element-91">
      <div className="container-custom" data-id="element-92">
        <span className="section-tag" data-id="element-93">Este método es para vos si...</span>
        <h2 className="section-title mb-10" data-id="element-94">
          ¿TE IDENTIFICÁS
          <br data-id="element-95" />
          CON ALGUNO DE ESTOS?
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-96">
          {cards.map((card, idx) => <div key={idx} className={`bg-card border rounded-[10px] p-[22px_24px] flex items-start gap-3.5 ${card.highlight ? 'border-pink bg-[rgba(233,30,140,0.07)]' : 'border-border'}`} data-id="element-97">
              <div className="text-[22px] shrink-0 mt-0.5" data-id="element-98">{card.icon}</div>
              <p className="text-[15px] text-text leading-[1.5]" data-id="element-99">
                <strong className={`block text-[13px] uppercase tracking-[1px] mb-1 ${card.highlight ? 'text-green' : 'text-pink'}`} data-id="element-100">
                  {card.title}
                </strong>
                {card.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}